<search-dropdown 
  [items]="technicians" 
  [label]="'name'" 
  [uid]="'id'" 
  [placeholder]="_placeholder"
  (afterChange)="technicianChanged($event)"
  [(ngModel)]="technicianId">
</search-dropdown>